import { useEffect, useState } from 'react';

type Props = {
  daysLeft: number | null;
  isFreeTrialValid: boolean;
  upgradeSubscriptions: () => void;
  dashboardListInfo: any;
};

const getPackageTrialTxtList = (list_info: any) => {
  let txtList = [];

  for(let i = 0; i < list_info.length; i++){
    if(list_info[i].trialRemainingDays && list_info[i].trialRemainingDays > 0){
      txtList.push(list_info[i].subject + " trial " + list_info[i].trialRemainingDays + " days left");
    }
  }

  return txtList;
};

const FreeTrialBanner: React.FC<Props> = ({
  daysLeft,
  isFreeTrialValid,
  upgradeSubscriptions,
  dashboardListInfo,
}) => {
  const [trialTxtList, setTrialTxtList] = useState<any>();

  useEffect(() => {
    setTrialTxtList(getPackageTrialTxtList(dashboardListInfo));   
  }, [dashboardListInfo]);  

  return (
    <div className="FreeTrialBannerContainer">
      <div className="FreeTrialBanner WidthContent">
        {isFreeTrialValid && daysLeft && daysLeft > 1 ? (
          <>
            {trialTxtList && trialTxtList.map((item: string, index: number) => {
              return (
                <span key={index}>{item}</span>
              );
            })}
          </>
        ) : (
          <span>Upgrade to a full subscription now to maintain access</span>
        )}

        {trialTxtList && trialTxtList.length !== dashboardListInfo.length && 
          <button
            onClick={() => upgradeSubscriptions()}
            className="Btn BtnOrange TileButton SlimButton"
          >
            Upgrade to subscription
          </button>
        }
      </div>
    </div>
  );
};

export default FreeTrialBanner;
